<template>
	<AppLazyLoaderComponentFromMonolith
		:params="params"
		:container="Monolith.LAZY_CONTAINER.COMMENTS"
	/>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { type Project } from '@/generated/graphql';

const props = defineProps<{
	projectId: Project['id'];
}>();

const params = computed(() => ({
	project_id: String(props.projectId),
}));
</script>
